const feedbacks = {
  toasts: {
    create: {
      success: 'Feedback creado correctamente',
      error: 'Ocurrió un error al crear el feedback',
    },
    fetch: {
      error: 'Ocurrió un error al obtener los feedbacks',
    },
    delete: {
      error: 'Ocurrió un error al eliminar el feedback',
    },
  },
  deleteModal: {
    header: 'Eliminar feedback',
    body: 'Está a punto de eliminar un feedback',
    bulkBody: 'Está a punto de eliminar {{num}} feedbacks',
    success: 'Feedback eliminado correctamente',
  },
  table: {
    headers: {
      date: 'Fecha',
      source: 'Origen',
      id: 'ID',
      externalId: 'ID externo',
      flight: 'Vuelo',
      airline: 'Aerolínea',
      account: 'Cuenta',
      driver: 'Conductor',
      vehicle: 'Vehículo',
      feedback: 'Feedback',
      rating: 'Calificación',
      by: 'Por',
      phone: 'Teléfono',
      contact: 'Contacto',
    },
    filters: {
      flight: 'Vuelo',
      airline: 'Aerolínea',
      driver: 'Conductor',
      vehicle: 'Vehículo',
    },
    source: {
      crewLink: 'CrewLink',
      qr: 'QR',
      tripCard: 'Tarjeta de viaje',
    },
    actions: {
      delete: 'Eliminar',
    },
    toolTip: {
      noPermission: 'Acción no permitida: se requiere permiso',
    },
  },
};

export default feedbacks;
